/**
 * Employee status helpers — align with EmployeeManagement + EmployeeCashManager.
 * Wallet / settlement pickers must only list employees who can hold new transactions.
 */

const INACTIVE_STATUSES = new Set([
  'inactive',
  'deleted',
  'suspended',
  'removed',
  'deactivated',
]);

export function normalizeEmployeeStatus(employee) {
  if (!employee) return '';
  return String(employee.status ?? 'active').trim().toLowerCase();
}

/** True only when employee may receive wallet / cash-flow / settlement actions. */
export function isEmployeeActive(employee) {
  if (!employee) return false;
  if (employee.isRemoved === true || employee.isDeleted === true) return false;
  if (employee.deleted_at != null || employee.removedAt != null) return false;

  const status = normalizeEmployeeStatus(employee);
  if (!status || INACTIVE_STATUSES.has(status)) return false;
  return status === 'active';
}

export function filterActiveEmployees(employees = []) {
  return (employees || []).filter(isEmployeeActive);
}
